import Vue from 'vue';
import Vuex from 'vuex';

import { Api } from '@/api/core';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state() {
    return {
      siteName: undefined,
      viewName: undefined,
      meta: {},
    };
  },
  getters: {
    title({ siteName, viewName }) {
      if (!viewName) {
        return siteName;
      }

      return `${viewName} - ${siteName}`;
    },
  },
  mutations: {
    setSiteName(state, siteName) {
      state.siteName = siteName;
    },
    setViewName(state, viewName) {
      state.viewName = viewName.replace(/&#8217;/g, "'").replace(/&#8211;/, '-').replace(/&#038;/g, '&');
    },
  },
  actions: {
    async fetchSiteName({ commit }) {
      commit('setSiteName', (await new Api().get()).name);
    },
  },
});

store.watch((state, { title }) => title, (title) => {
  document.title = title;
});

export default store;
